import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { highlight } from '../actions/general-actions';

const mapStateToProps = (state, ownProps) => {
  const { device, id, category } = ownProps,
        { highlightedId } = state.model[device].present,

        /**
         * This works even for the three Grids (desktop, tablet and mobile)
         * since when no especial element (Row, Column and Element) are selected,
         * then highlighted element for each device must be Grid itself.
         * (Default highlighted element)
         */
        isHighlighted =
          (id === highlightedId) ||
          (!highlightedId && category === 'CONTAINER');

  return {
    isHighlighted
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onHighlight(e) {
      e.stopPropagation();
      dispatch(highlight({ device, id }));
    }
  };
};

const Highlightable = () => {
  return (Component) => connect(
    mapStateToProps,
    mapDispatchToProps
  )(props => <Component {...props} />);
};

export default Highlightable;



// WEBPACK FOOTER //
// ./app/header-builder/HOCs/Highlightable.js